export default function AboutFoodIcon() {
  return (
    <>
      <path
        id='Vector'
        d='M77.7846 59.5103L77.7945 59.75H78.0344H81.6344C82.5809 59.75 83.3844 60.6221 83.3844 61.6C83.3844 62.5619 82.5963 63.35 81.6344 63.35H8.23438C7.27245 63.35 6.48438 62.5619 6.48438 61.6C6.48438 60.6381 7.27245 59.85 8.23438 59.85H11.8344H12.0742L12.0842 59.6103C12.6788 45.2397 23.8813 33.3275 38.679 30.646L39.1666 30.5576L38.8057 30.218C37.1574 28.6666 36.1844 26.4332 36.1844 24C36.1844 19.1381 40.0724 15.25 44.9344 15.25C49.7963 15.25 53.6844 19.1381 53.6844 24C53.6844 26.4301 52.7136 28.5645 51.063 30.1179L50.7021 30.4576L51.1898 30.546C65.9875 33.2275 77.1899 45.1397 77.7846 59.5103ZM74.0344 59.85H74.2969L74.2841 59.5878C73.5768 45.1395 60.652 33.55 44.9344 33.55C29.2175 33.55 16.2919 45.0388 15.5847 59.5879L15.5719 59.85H15.8344H74.0344ZM50.1844 24C50.1844 21.0619 47.8724 18.75 44.9344 18.75C41.9963 18.75 39.6844 21.0619 39.6844 24C39.6844 26.9381 41.9963 29.25 44.9344 29.25C47.8724 29.25 50.1844 26.9381 50.1844 24Z'
        stroke='white'
        strokeWidth='0.5'
        fill='#38383A'
      />
      <path
        id='Vector_2'
        d='M8.23438 70.6504H81.6344C82.5963 70.6504 83.3844 71.4385 83.3844 72.4004C83.3844 73.3623 82.5963 74.1504 81.6344 74.1504H8.23438C7.27245 74.1504 6.48438 73.3623 6.48438 72.4004C6.48438 71.4385 7.27245 70.6504 8.23438 70.6504Z'
        stroke='white'
        strokeWidth='0.5'
        fill='#38383A'
      />
    </>
  );
}
